import { render, staticRenderFns } from "./DeParaVariantesDaNota.vue?vue&type=template&id=cc7229c8&scoped=true&"
import script from "./DeParaVariantesDaNota.vue?vue&type=script&lang=ts&"
export * from "./DeParaVariantesDaNota.vue?vue&type=script&lang=ts&"
import style0 from "./DeParaVariantesDaNota.vue?vue&type=style&index=0&id=cc7229c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7229c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VIcon,VSpacer})
